export default __webpack_public_path__ + "static/media/BannerChart.fd182da2.jpg";